import { render, staticRenderFns } from "./PlusParasite.vue?vue&type=template&id=452f3df2&scoped=true"
import script from "./PlusParasite.vue?vue&type=script&lang=js"
export * from "./PlusParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f3df2",
  null
  
)

export default component.exports